import { render } from "./LocationReport.vue?vue&type=template&id=6b305ced&ts=true"
import script from "./LocationReport.vue?vue&type=script&lang=ts"
export * from "./LocationReport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__